import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { vanLessons } from '../../mocks/van-lessons';

const VanPage = () => {
  const categories = ['Văn học hiện đại', 'Văn học nước ngoài', 'Kỹ năng viết', 'Truyện ngắn'];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-rose-50 via-pink-50 to-red-50 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img 
              src="https://public.readdy.ai/ai/img_res/33dfe2942c74e39d3fc4cbabf22f2322.jpg"
              alt="Văn học background"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="max-w-7xl mx-auto text-center relative z-10">
            <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-book-open-fill"></i>
              <span>Ngữ Văn</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Ngữ Văn Lớp 6-12
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Tổng hợp kiến thức văn học toàn diện với phân tích tác phẩm chi tiết, văn mẫu hay, 
              kỹ năng làm bài và phương pháp học hiệu quả cho học sinh THCS & THPT
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <a href="#bai-hoc" className="px-8 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                Xem bài học
              </a>
              <a href="#danh-muc" className="px-8 py-3 bg-white text-red-600 rounded-lg font-medium border-2 border-red-600 hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer">
                Danh mục
              </a>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-12 px-6 bg-white border-b">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-red-600 mb-2">{vanLessons.length}+</div>
                <div className="text-gray-600">Bài học</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-red-600 mb-2">500+</div>
                <div className="text-gray-600">Văn mẫu</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-red-600 mb-2">200+</div>
                <div className="text-gray-600">Tác phẩm</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-red-600 mb-2">1000+</div>
                <div className="text-gray-600">Bài tập</div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section id="danh-muc" className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" style={{ fontFamily: 'Merriweather, serif' }}>
              Danh Mục Văn Học
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {categories.map((category, index) => (
                <a 
                  key={index}
                  href={`#${category.toLowerCase().replace(/\s+/g, '-')}`}
                  className="group bg-white p-8 rounded-xl border-2 border-gray-200 hover:border-red-500 hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-book-2-fill text-white text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{category}</h3>
                  <p className="text-sm text-gray-600">
                    {vanLessons.filter(l => l.category === category).length} bài học
                  </p>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Lessons Section */}
        <section id="bai-hoc" className="py-16 px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
                Bài Học Văn Học
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Phân tích tác phẩm văn học chi tiết với lý thuyết đầy đủ, ví dụ minh họa và bài tập thực hành
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {vanLessons.map((lesson) => (
                <article key={lesson.id} className="bg-white rounded-xl border border-gray-200 hover:shadow-xl transition-all overflow-hidden group">
                  <div className="h-48 bg-gradient-to-br from-red-100 to-pink-100 relative overflow-hidden">
                    <img 
                      src={`https://readdy.ai/api/search-image?query=elegant%20vietnamese%20literature%20book%20open%20pages%20with%20traditional%20calligraphy%20and%20poetry%20artistic%20illustration%20in%20soft%20rose%20pink%20tones%20scholarly%20atmosphere&width=600&height=400&seq=van-${lesson.id}&orientation=landscape`}
                      alt={lesson.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 object-top"
                    />
                    <div className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                      Lớp {lesson.grade}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                      <span className="bg-red-100 text-red-700 px-2 py-1 rounded">{lesson.category}</span>
                      <span>•</span>
                      <span><i className="ri-time-line"></i> {lesson.readTime} phút</span>
                      <span>•</span>
                      <span><i className="ri-eye-line"></i> {lesson.views.toLocaleString()}</span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-red-600 transition-colors">
                      {lesson.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {lesson.excerpt}
                    </p>
                    <a 
                      href={`/van/${lesson.slug}`}
                      className="inline-flex items-center gap-2 text-red-600 font-medium text-sm hover:gap-3 transition-all cursor-pointer"
                    >
                      Xem chi tiết
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-red-600 to-pink-600 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              Bắt Đầu Học Văn Ngay Hôm Nay
            </h2>
            <p className="text-xl mb-8 text-red-50">
              Nâng cao kỹ năng văn học và đạt điểm cao trong các kỳ thi
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="#bai-hoc" className="px-8 py-4 bg-white text-red-600 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Khám phá ngay
              </a>
              <a href="/lien-he" className="px-8 py-4 bg-red-700 text-white rounded-lg font-medium hover:bg-red-800 transition-colors border-2 border-white/30 whitespace-nowrap cursor-pointer">
                Liên hệ tư vấn
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default VanPage;
